import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import globals from '#utilities/js/ea/globals.js'
import * as utilities from '#utilities/js/styles.js'
import { elements } from '../../../styles.js'

const onClick = object(listener, {
  type: click,
  passive,
  task: (
    element
  ) => {
    const id = element.getAttribute('data-id')
    globals.ea_meet_div(id, { join: 1 })
  }
})

export default element => {
  /* le dernier meet-id sera utilisé pour le bouton */
  if (element.classList.contains(`${elements.message_meeting}`)) {
    let buttonJoin = one(`.${elements.join}`, element.closest('body'))
    if (!buttonJoin) {
      /* cas du refresh */
      buttonJoin = one(`.${elements.join}`, element.ownerDocument)
    }
    let buttonCall = one(`.${elements.call}`, element.closest('body'))
    if (!buttonCall) {
      /* cas du refresh */
      buttonCall = one(`.${elements.call}`, element.ownerDocument)
    }
    if (buttonJoin) {
      buttonJoin.setAttribute('data-id', element.getAttribute('data-id'))
      buttonJoin.classList.remove(utilities.modifiers.display.none)
    }
    if (buttonCall) {
      buttonCall.classList.add(utilities.modifiers.display.none)
    }
  }
  /* listener */
  onClick.listen(element)
}
